import React from 'react';
const blockName = 'match-result-component';
const teamScoreElement = 'team-score';

export default function MatchWithResult({ result, }){
  return (
    <div className={ `${ blockName }__container` } >
      <span className={ `${ blockName}__${ teamScoreElement } ${ blockName}__${ teamScoreElement }--home` }>
        { result.home }
      </span>
      <span className={ `${ blockName }__seperator` }>
       :
      </span>
      <span className={ `${ blockName}__${ teamScoreElement } ${ blockName}__${ teamScoreElement }--away` }>
        { result.away }
      </span>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchWithResult.js